<template>
	<div id="" style="width: 100%;height: 100%;" class="home">
		<el-container style="height: 100%;" v-if="$route.meta.keepAlive">
			<el-header style="height: 70px;z-index: 1;">
				<el-col :span="5" style="text-align: right;">
					<img :src="require('../assets/logo.png')" @click="$router.push({path:'/index'})"
						:style="{verticalAlign:'middle'}" />
				</el-col>
				<el-col :span="13">
					<el-menu :default-active="activeIndex" background-color="#fff" text-color="#333"
						:style="{border:'none',fontSize:'16px',float:'right',marginRight:'70px'}" router
						active-text-color="#0076fe" mode="horizontal" :unique-opened="true" @select="handleSelect">
						<fragment v-for="item in menus" :key="item.id">
							<el-menu-item :index="item.url" :title="item.name">
								<template slot="title">
									<span slot="title">{{item.name}}</span>
								</template>
							</el-menu-item>
						</fragment>
					</el-menu>
				</el-col>
				<el-col :span="6">
					<el-button size="medium" round @click="jump">免费创建</el-button>
					<el-button size="medium" type="primary" round
						@click="$router.push({path:(userId!=null?'/aIndex':'/login')})" style="
                background: linear-gradient(0deg, #4760ff 0%, #0dccff 100%);
                margin-left: 20px;">
						{{userId!=null?'个人中心':'登录/注册'}}
					</el-button>
				</el-col>
			</el-header>

			<el-main ref="scrollDiv">
				<router-view v-if="isRouterAlive"></router-view>

				<!-- 底部 -->
				<el-row class="base" v-if="footShow">
					<el-row class="hw-footer-container" :gutter="20">
						<el-col :span="6">
							<label>友情链接</label>
							<el-row class="worksBox" type="flex" :gutter="10">
								<el-col>
									<a href="javascript:void(0)"><img :src="require('../assets/logo.png')" /></a>
								</el-col>
								<el-col>
									<a href="javascript:void(0)"><img
											:src="require('../assets/xiaochengxulogo.png')" /></a>
								</el-col>
								<el-col>
									<a href="javascript:void(0)"><img
											:src="require('../assets/duanxin_logo.png')" /></a>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="4">
							<label>产品介绍</label>
							<a href="javascript:void(0)">图文投票活动</a>
							<a href="javascript:void(0)">视频投票活动</a>
							<a href="javascript:void(0)">多分组投票活动</a>
							<a href="javascript:void(0)">在线自助报名活动</a>
						</el-col>
						<el-col :span="4">
							<label>适用场景</label>
							<a href="javascript:void(0)">视频展示</a>
							<a href="javascript:void(0)">单位评选</a>
							<a href="javascript:void(0)">萌娃评选</a>
							<a href="javascript:void(0)">摄影大赛</a></el-col>
						<el-col :span="4">
							<label>关于我们</label>
							<a href="javascript:void(0)">公司简介</a>
							<a href="javascript:void(0)">企业文化</a>
							<a href="javascript:void(0)">企业精神</a>
							<a href="javascript:void(0)">加入我们</a></el-col>
						<el-col :span="6">
							<label>联系我们</label>
							<el-row type="flex">
								<label class="hw-label">业务咨询：</label>
								<a href="javascript:void(0)">contact.hewen@qq.com</a>
							</el-row>
							<el-row type="flex">
								<label class="hw-label">联系电话：</label>
								<a href="javascript:void(0)">15395111931</a>
							</el-row>
							<el-row type="flex">
								<label class="hw-label">公司地址：</label>
								<a href="javascript:void(0)">安徽省合肥市高新区天源迪科科技园3号楼406</a>
							</el-row>
						</el-col>
					</el-row>
					<el-row class="copyrightBox" type="flex" align="middle" justify="center">
						<img :src="require('../assets/login-gongan.png')" />
						<a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #FFFFFF;">
							皖ICP备19019663号 Copyright © 2017-{{nowYear}}
							安徽和文信息技术有限公司 版权所有
						</a>
						<!-- 						<a href="##" target="_blank" style="position: relative;display: inline-block;height: 38px;">
							<div style="width:100%;height:100%;position: absolute;top: 0;left: 0;"></div>
							<embed src="https://program.xinchacha.com/web/1501090762857553920=*.17716.cn.svg"
								width="103" height="38" type="image/svg+xml"
								pluginspage="//www.adobe.com/svg/viewer/install/" />
						</a> -->
					</el-row>
				</el-row>

				<!-- 联系我们 -->
				<ul class="hang-right" v-if="footShow">
					<li>
						<a href="javascript:void(0)">
							<img src="../assets/dh.png" />
							<img src="../assets/dhBtn.png" />
						</a>
						<div class="cndns-right-box">
							<div class="box-border" style="width: 330px">
								<div class="sev-t">
									<span class="demo-icon"><i class="el-icon-phone-outline"
											style="font-size: 42px;color: #d3d3d3;line-height: 56px;"></i></span>
									<p style="font-size: 16px">
										15395111931<br /><i style="font-size: 16px">7*12小时客服服务热线</i>
									</p>
									<div class="clear"></div>
								</div>
								<span class="arrow-right"></span>
							</div>
						</div>

					</li>
					<li>
						<a href="javascript:void(0)">
							<img src="../assets/erweima.png" />
							<img src="../assets/ewmBtn.png" />
						</a>

						<div class="cndns-right-box">
							<div class="box-border">
								<div class="sev-t">
									<img src="../assets/kferm.jpg" style="height: 156px; width: 154px" />
									<i style="text-align: center">7*12小时咨询服务</i>
								</div>
								<span class="arrow-right"></span>
							</div>
						</div>
					</li>
					<li>
						<a href="javascript:void(0)">
							<img src="../assets/QQ.png" />
							<img src="../assets/qqBtn.png" />
						</a>
						<div class="cndns-right-box">
							<div class="box-border" style="width: 430px">
								<div class="sev-t">
									<span class="demo-icon"><i class="el-icon-headset"
											style="font-size: 42px;color: #d3d3d3;line-height: 56px;"></i></span>
									<p>在线客服<i>服务时间：9:00-17:30</i></p>
									<div class="clear"></div>
								</div>
								<div class="sev-b">
									<ul id="zixunUl">
										<li>
											<a
												href="tencent://message/?Uin=3434459136&amp;Site=www.17716.cn&amp;Menu=yes">客服001</a>
										</li>
										<li>
											<a
												href="tencent://message/?Uin=2441616002&amp;Site=www.17716.cn&amp;Menu=yes">客服002</a>
										</li>
										<div class="clear"></div>
									</ul>
								</div>
								<span class="arrow-right"></span>
							</div>
						</div>
					</li>
					<li>
						<a href="javascript:void(0)" v-on:click="toTop">
							<img src="../assets/Top.png" />
							<img src="../assets/TopBtn.png" />
						</a>
					</li>
				</ul>
			</el-main>
		</el-container>
		<router-view v-else />
	</div>
</template>

<script>
	import bus from './../common/bus.js';
	export default {
		name: 'home',
		components: {},
		data() {
			return {
				isRouterAlive: true, //路由刷新
				activeIndex: '/index',
				nowYear: '',
				menus: [{
						name: "首页",
						id: "1",
						icon: "el-icon-user-solid",
						url: "/index",
					},
					{
						name: "模板中心",
						id: "2",
						icon: "el-icon-goods",
						url: "/template",
					},
					{
						name: "案例中心",
						id: "3",
						icon: "el-icon-s-management",
						url: "/case",
					},
					{
						name: "产品中心",
						id: "4",
						icon: "el-icon-document",
						url: "/product",
					},
					{
						name: "帮助中心",
						id: "5",
						icon: "el-icon-s-operation",
						url: "/help",
					},
					{
						name: "关于我们",
						id: "6",
						icon: "el-icon-picture",
						url: "/about",
					}
				], //导航列表
				Imenus: [{
						name: "首页",
						id: "1",
						icon: "el-icon-house",
						url: "/aIndex",
					},
					{
						name: "活动管理",
						id: "2",
						icon: "el-icon-menu",
						url: "/aActivty",
					},
					{
						name: "活动模板",
						id: "3",
						icon: "el-icon-s-management",
						url: "/aTemplate",
					},
					{
						name: "定制服务",
						id: "4",
						icon: "el-icon-s-opportunity",
						url: "/aService",
					}
				],
				footShow: this.$route.name == 'login' ? false : true,
				userId: null,
			}
		},
		mounted() {
			let userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');
			if (userInfo != {}) {
				this.userId = userInfo.id;
			}
		},
		mounted() {
			this.onRouteChanged();
			this.getNowYear();
			let userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');
			if (userInfo != {}) {
				this.userId = userInfo.id;
			}
		},
		methods: {
			jump() {
				if (this.userId) {
					window.location = '#/vote';
				} else {
					window.location = '#/login';
				}
				this.reload();
			},
			getNowYear() {
				this.nowYear = new Date().getFullYear();
			},
			reload() { //刷新路由
				this.isRouterAlive = false;
				this.$nextTick(() => {
					this.isRouterAlive = true;
				})
			},
			onRouteChanged() {
				this.activeIndex = this.$route.path; //导航变化
			},
			handleSelect(index, indexPath) {
				bus.$emit('navPath', indexPath);
				this.toTop();
			},
			toTop() { // 回到顶部
				// 实现滚动效果
				const timeTop = setInterval(() => {
					this.$refs.scrollDiv.$el.scrollTop = 0;
					if (this.$refs.scrollDiv.$el.scrollTop === 0) {
						clearInterval(timeTop);
					}
				}, 10);
			},
		},
		provide() {
			return {
				reload: this.reload //提供数据
			}
		},
		watch: {
			// 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
			$route(url, old) {
				let userInfo = JSON.parse(localStorage.getItem("userInfo") || '{}');
				if (userInfo != {}) {
					this.userId = userInfo.id;
				}
				if (url.name == 'login') {
					this.footShow = false;
				} else {
					this.footShow = true;
				}
				this.onRouteChanged();
			}
		},
	}
</script>

<style>
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		color: #2c3e50;
	}

	* {
		margin: 0;
		padding: 0;
	}

	html,
	body,
	#app {
		width: 100%;
		height: 100%;
		/* background: #f2f2f4; */
	}

	.el-menu {
		height: 100%;
	}

	header {
		line-height: 70px;
		box-shadow: 0 1px 2px 0 rgba(0, 0, 0, .1);

	}

	.el-main {
		padding: 2px 0 !important;
	}

	.el-menu--horizontal>.el-menu-item {
		font-size: 15px;
	}

	.el-button--medium {
		font-size: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/home.vue